import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { NOTIFICATION_TYPE } from '../../../../../../utilities/constants';
import { Alert, ALERT_TYPES } from '../../../../../Alert';
import { Box, Text } from '../../../../../ui-kit';
import { SummaryContent } from '../../../Content';

const propTypes = {
  /** Flag to indicate if the alert is shown */
  showNotification: PropTypes.bool,

  /** Message for the notification */
  notificationMessage: PropTypes.string,

  /** Type for the notification */
  notificationType: PropTypes.string,

  /** Alert message that comes with the reservation, shown when there is no local notification */
  summaryAlert: PropTypes.string
};

export const SummaryAlert = ({ showNotification, notificationMessage, notificationType, summaryAlert }) => {
  const [renderAlert, setRenderAlert] = useState(showNotification);

  useEffect(() => {
    setRenderAlert(showNotification || Boolean(summaryAlert));
  }, [showNotification, summaryAlert]);

  if (!renderAlert) return null;

  const message = showNotification ? notificationMessage : summaryAlert;
  const variant = notificationType === NOTIFICATION_TYPE.failed ? ALERT_TYPES.warning : ALERT_TYPES.success;

  return (
    <SummaryContent.Item>
      <Box mt="1px" mb="-10px" width="100%">
        <Alert variant={variant} icon>
          <Text color="nightSkyBlack.80" fontWeight="medium">
            {ReactHtmlParser(message)}
          </Text>
        </Alert>
      </Box>
    </SummaryContent.Item>
  );
};

SummaryAlert.propTypes = propTypes;
SummaryAlert.defaultProps = {
  showNotification: false,
  notificationType: NOTIFICATION_TYPE.success
};
